import { render, staticRenderFns } from "./-error404.vue?vue&type=template&id=004e10bf&scoped=true"
import script from "./-error404.vue?vue&type=script&lang=js"
export * from "./-error404.vue?vue&type=script&lang=js"
import style0 from "./-error404.vue?vue&type=style&index=0&id=004e10bf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004e10bf",
  null
  
)

export default component.exports